import { render, staticRenderFns } from "./ProductSetting.vue?vue&type=template&id=5a5631f6&scoped=true&"
import script from "./ProductSetting.vue?vue&type=script&lang=js&"
export * from "./ProductSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetting.vue?vue&type=style&index=0&id=5a5631f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5631f6",
  null
  
)

export default component.exports